import { render, staticRenderFns } from "./posPerformanceResume.vue?vue&type=template&id=c2ad44a0&"
import script from "./posPerformanceResume.vue?vue&type=script&lang=js&"
export * from "./posPerformanceResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports